var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[
		_vm.showSpinner
			? 'state waiting'
			: _vm.disableOnSuccess
				? 'state success'
				: '',
		_vm.btnClass ],attrs:{"type":"button"}},[(_vm.showSpinner)?_c('span',[_vm._v("Wait...")]):(_vm.disableOnSuccess)?_c('span',[_vm._v("Success!")]):_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }